var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"selector_chainlink empty"},[_c('div',{staticClass:"i-v-input"},[_c('span',{staticClass:"label"},[_vm._v("Empty")])])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a8c8d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selector/Empty.vue
// module id = null
// module chunks = 